import {
	BetSlipNotificationPayload,
	EventEndNotificationPayload,
	EventNotificationPayload,
	Payload,
} from "./pushNotificationTypes";

export function createSearchQueryForEndEventFromResult(payload: string) {
	const params = new URLSearchParams();
	params.append("payload", payload);

	return params.toString();
}

export function isValidEndEventPayload(
	payload: Payload
): payload is EventEndNotificationPayload {
	//required properties for current functionality
	const payloadProperties = [
		"eventId",
		"matchStatusAbrv",
		"result",
		// "sport",
		// "category",
		// "tournament",
	];

	return payloadProperties.every((property: string) => property in payload);
}

export function isFullTimeScoreInResult(payload: EventEndNotificationPayload) {
	const result = payload.result;
	const parsedResult = JSON.parse(result);

	//required property for current functionality
	return parsedResult?.fullTimeScore != null;
}

export function isValidEventPayload(
	payload: Payload
): payload is EventNotificationPayload {
	//required properties for current functionality
	const payloadProperties = ["eventId", "matchStatusAbrv"];

	return payloadProperties.every((property: string) => property in payload);
}

export function isValidBetSlipPayload(
	payload: Payload
): payload is BetSlipNotificationPayload {
	//required properties for current functionality
	const payloadProperties = ["betSlipId", "userId"];

	return payloadProperties.every((property: string) => property in payload);
}

export function parsePayloadForUI(unparsedPayload: string) {
	const info = JSON.parse(unparsedPayload);
	const parsedResult = JSON.parse(info.result);
	return {
		...info,
		result: parsedResult,
	};
}
